import { Developer } from 'src/app/shared/models/developer.model';

export const developers: Developer[] = [
  {
    firstName: 'Zach',
    lastName: 'Chin',
    imageName: 'zach_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/zchin18/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science, ', 'BA Mathematics'],
    hobby: 'Dancing and playing guitar',
  },
  {
    firstName: 'Won-Seok',
    lastName: 'Park',
    imageName: 'wonseok_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/won-seok-park-4b9a5649/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science, ', 'BS Biochemistry'],
    hobby: 'E-Sports and traveling',
  },
  {
    firstName: 'Nathan',
    lastName: 'Wang',
    imageName: 'nathan_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/nathan-wang-from-calvin-university/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science, ', 'Minor in German and Accounting'],
    hobby: 'Photography and traveling',
  },
  {
    firstName: 'Jack',
    lastName: 'Westel',
    imageName: 'jack_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/jack-westel-6b614b194/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science, ', 'Minor in Writing'],
    hobby: 'Playing ultimate frisbee and badminton',
  },
  {
    firstName: 'Chris',
    lastName: 'Wierenga',
    imageName: 'chris_profile.jpeg',
    contactLink: 'https://calvin.edu/directory/people/christopher-wieringa',
    hasLinkedIn: false,
    degreeInfo: [
      'Computer Science Adjunct Professor @ Calvin University, ',
      'MS Computer and Information Systems',
    ],
    hobby: 'Mentoring CS students on their senior project',
  },
];

export const developers2024: Developer[] = [
  {
    firstName: 'Anne',
    lastName: 'Gritter',
    imageName: 'anne_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/anne-gritter/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science,', ' Minor in Electrical Engineering and Mathematics'],
    hobby: 'Kayaking and origami',
  },
  {
    firstName: 'Chang',
    lastName: 'Liu',
    imageName: 'chang_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/chang-liu-41900923a/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science,', ' Minor in Mathematics'],
    hobby: 'Anime, sudoku, and softball',
  },
  {
    firstName: 'Lydia',
    lastName: 'Powers',
    imageName: 'lydia_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/lydia-powers/',
    hasLinkedIn: true,
    graduation: new Date('4/29/2022'),
    degreeInfo: ['BCS Computer Science and Asian Studies,', ' Minor in Mathematics'],
    hobby: 'Brazilian Jiujitsu, cooking, and reading',
  },
  {
    firstName: 'Chris',
    lastName: 'Wierenga',
    imageName: 'chris_profile.jpeg',
    contactLink: 'https://calvin.edu/directory/people/christopher-wieringa',
    hasLinkedIn: false,
    degreeInfo: [
      'Computer Science Adjunct Professor @ Calvin University, ',
      'MS Computer and Information Systems',
    ],
    hobby: 'Mentoring CS students on their senior project',
  },
];

export const developer2025: Developer[] = [
  {
    firstName: 'Tyler',
    lastName: 'Arista',
    imageName: 'tyler_profile.jpg',
    contactLink: 'https://www.linkedin.com/in/tyler-arista/',
    hasLinkedIn: true,
    graduation: new Date('5/10/2025'),
    degreeInfo: ['BCS Computer Science,', ' Minor in Data Science'],
    hobby: 'Sports, cooking, and traveling',
  },
  {
    firstName: 'Victor',
    lastName: 'Norman',
    imageName: 'victor_profile.jpg',
    contactLink: 'https://calvin.edu/people/victor-t-norman',
    hasLinkedIn: false,
    degreeInfo: ['Computer Science Associate Professor @ Calvin University, ', 'PhD'],
    hobby: 'Building apps, playing the euphonium, golfing, snorkeling and sailing',
  },
  {
    firstName: 'Chris',
    lastName: 'Wierenga',
    imageName: 'chris_profile.jpeg',
    contactLink: 'https://calvin.edu/directory/people/christopher-wieringa',
    hasLinkedIn: false,
    degreeInfo: [
      'Computer Science Adjunct Professor @ Calvin University, ',
      'MS Computer and Information Systems',
    ],
    hobby: 'Mentoring CS students on their senior project',
  },
];

export const developer2026: Developer[] = [
  {
    firstName: 'Peter',
    lastName: 'Lund',
    imageName: 'peter_profile.jpg',
    contactLink: 'https://www.linkedin.com/in/peter-benjamin-lund/',
    hasLinkedIn: true,
    degreeInfo: ['BCS Computer Science', ' Minor in Mathematics'],
    hobby: 'Game development, playing tennis, cooking',
  },
  {
    firstName: 'Alvin',
    lastName: 'Waigwa',
    imageName: 'alvin_profile.jpeg',
    contactLink: 'https://www.linkedin.com/in/alvin-wandimi/',
    hasLinkedIn: true,
    degreeInfo: ['BCS Computer Science', ' Minor in Mathematics'],
    hobby: 'Playing football',
  },
  {
    firstName: 'Swayam',
    lastName: 'Shrestha',
    imageName: 'swayam_profile.jpg',
    contactLink: 'https://www.linkedin.com/in/swayam-shrestha/',
    hasLinkedIn: true,
    degreeInfo: ['BCS Computer Science, ', 'Minor in Business'],
    hobby: 'Playing guitar, cooking',
  },
  {
    firstName: 'Victor',
    lastName: 'Norman',
    imageName: 'victor_profile.jpg',
    contactLink: 'https://calvin.edu/people/victor-t-norman',
    hasLinkedIn: false,
    degreeInfo: ['Computer Science Associate Professor @ Calvin University, ', 'PhD'],
    hobby: 'Building apps, playing the euphonium, golfing, snorkeling and sailing',
  },
];
